import React, { memo } from 'react';
import DealNameSelect from '../DealNameSelect';
import { ActionsCell } from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/cellCallbacks';
import BondNameCell from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/BondNameCell/BondNameCell';

import styles from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/fieldRowStyles.module.scss';

const FieldRow = ({ data, rowIndex }) => {
  const { cusip } = data;

  return (
    <div className={ styles.row } data-test="positionRow">
      <div data-test="cusip" className={ styles.cusip }>{ cusip || '-' }</div>
      <div className={ styles.dealSelect }>{
        data?.isBondAutoSelected
            ? <BondNameCell row={ data } />
            : <DealNameSelect row={ data } rowIndex={ rowIndex } cellName="bond" />
      }
      </div>
      <div className={ styles.actionCell }>
        <ActionsCell rowIndex={ rowIndex } />
      </div>
    </div>
  );
};

export default memo(FieldRow);
